module.exports = __webpack_public_path__ + "img/logo.a6674d2b.png";